import { INDICATOR_COLORS } from "@/shared/components/gantt-carga/gantt-carga.constants";
import type { GanttIndicator } from "@/modules/carga-trabalho";

import type {
  IndicadoresDialogProps,
  IndicadoresDialogViewModel,
} from "./types-indicadores-dialog";

export function useIndicadoresDialog<K extends GanttIndicator>({
  opcoes,
  value,
  onSave,
  onCancel,
}: IndicadoresDialogProps<K>): IndicadoresDialogViewModel {
  return {
    options: opcoes.map(({ key, label }) => ({ key, label, color: INDICATOR_COLORS[key] })),
    value: opcoes.filter(({ key }) => value[key]).map(({ key }) => key),
    escolher: (ativos) =>
      onSave(
        Object.fromEntries(opcoes.map(({ key }) => [key, ativos.includes(key)])) as Record<
          K,
          boolean
        >,
      ),
    cancelar: onCancel,
  };
}
